// Spricht mit dem lokalen MaStR-Helfer (tools/mastr-helfer) auf dem Rechner des Mitarbeiters.
import { tokenSpeicher } from "./client";
import type { AusfuellErgebnis, HelferStatus } from "./typen";

export const HELFER_URL =
  (import.meta.env.VITE_MASTR_HELFER_URL as string | undefined)?.replace(/\/$/, "") ?? "http://127.0.0.1:8766";

export class HelferFehler extends Error {
  constructor(
    message: string,
    public readonly nichtErreichbar = false,
  ) {
    super(message);
    this.name = "HelferFehler";
  }
}

async function helferAnfrage<T>(pfad: string, optionen: { methode?: "GET" | "POST"; body?: unknown; timeoutMs?: number } = {}): Promise<T> {
  const { methode = "GET", body, timeoutMs = 5000 } = optionen;
  const abbruch = new AbortController();
  const timer = window.setTimeout(() => abbruch.abort(), timeoutMs);
  const kopf: Record<string, string> = {};
  const token = tokenSpeicher.lesen();
  if (token && methode === "POST") kopf.Authorization = `Bearer ${token}`;
  if (body !== undefined) kopf["Content-Type"] = "application/json";
  let antwort: Response;
  try {
    antwort = await fetch(`${HELFER_URL}${pfad}`, {
      method: methode,
      headers: kopf,
      body: body !== undefined ? JSON.stringify(body) : undefined,
      signal: abbruch.signal,
    });
  } catch (e) {
    const zeitueberschreitung = e instanceof DOMException && e.name === "AbortError";
    throw new HelferFehler(
      zeitueberschreitung
        ? "Der MaStR-Helfer hat nicht rechtzeitig geantwortet"
        : "MaStR-Helfer läuft nicht – bitte „MaStR-Helfer starten.bat“ doppelklicken",
      !zeitueberschreitung,
    );
  } finally {
    window.clearTimeout(timer);
  }
  const daten = (await antwort.json().catch(() => ({}))) as T & { fehler?: string };
  if (!antwort.ok) throw new HelferFehler(daten.fehler ?? `Helfer-Fehler (HTTP ${antwort.status})`);
  return daten;
}

export const mastrHelfer = {
  status: () => helferAnfrage<HelferStatus>("/status", { timeoutMs: 2500 }),
  browserOeffnen: () => helferAnfrage<{ status: string }>("/browser-oeffnen", { methode: "POST" }),
  ausfuellen: (anlageId: number) =>
    helferAnfrage<AusfuellErgebnis>("/ausfuellen", { methode: "POST", body: { anlage_id: anlageId }, timeoutMs: 180_000 }),
};
